import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import grid from '../components/Grid/gridReducer';
import agenda from '../agenda';
import app from './appReducer';
import sidebar from './sidebarReducer';
import richText from '../components/RichTextEditor/reducer';
import { keyBy, mapValues } from 'lodash';

export default combineReducers({
  routing,
  richText,
  form,
  grid,
  app,
  sidebar,
  ...mapValues(keyBy(agenda, 'name'), 'reducer'),
});
